import palette from '../palette';

export default {
    root: {
        '&.Mui-focused': {
            color: palette.secondary.main,
        },
    },
};
